var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 10.4165L12.9168 10.4165",
    stroke: "white",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 12.9165L10.4168 12.9165",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5835 5.31651C4.5835 4.47643 4.5835 4.05639 4.74699 3.73552C4.8908 3.45328 5.12027 3.2238 5.40251 3.07999C5.72338 2.9165 6.14342 2.9165 6.9835 2.9165H10.2561C10.6229 2.9165 10.8064 2.9165 10.979 2.95795C11.1321 2.99469 11.2784 3.0553 11.4126 3.13754C11.564 3.23031 11.6937 3.36002 11.9531 3.61945L14.7139 6.38023C14.9733 6.63965 15.103 6.76937 15.1958 6.92074C15.278 7.05495 15.3386 7.20127 15.3754 7.35432C15.4168 7.52695 15.4168 7.7104 15.4168 8.07728V14.6832C15.4168 15.5232 15.4168 15.9433 15.2533 16.2642C15.1095 16.5464 14.8801 16.7759 14.5978 16.9197C14.2769 17.0832 13.8569 17.0832 13.0168 17.0832H6.98349C6.14342 17.0832 5.72338 17.0832 5.40251 16.9197C5.12027 16.7759 4.8908 16.5464 4.74699 16.2642C4.5835 15.9433 4.5835 15.5232 4.5835 14.6832V5.31651Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 2.9165V5.5165C10.4165 6.35658 10.4165 6.77662 10.58 7.09749C10.7238 7.37973 10.9533 7.6092 11.2355 7.75301C11.5564 7.9165 11.9764 7.9165 12.8165 7.9165H15.4165",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconW);
export default __webpack_public_path__ + "static/media/fileIconW.5328cfbcb9c09fb7cd26d2bada862a44.svg";
export { ForwardRef as ReactComponent };